$.fn.SoundRow = function() {
  let self = this

  if (self.data('sound-row')) {
    return self.data('sound-row')
  }

  self.el = {
    button: self.find('.sound-row__play'),
    ring: self.find('.progress-ring'),
    track: self.find('.progress-ring__track, .progress-ring__indicator'),
    progress: self.find('.progress-ring__indicator'),
  }

  self.playing = false
  self.ending = false
  self.audio = undefined
  self.progress_interval = undefined
  self.type = self.el.button.data('audio-file') ? 'mp3' : 'soundcloud';
  self.player = self.find('iframe').length ? SC.Widget(self.find('iframe').get(0)) : undefined
  self.duration = 0

  self.play = function() {
    self.playing = true
    self.addClass('sound-row--playing').removeClass('sound-row--paused')

    $.mlmi.players.forEach(function(player) {
      if (player != self) {
        player.pause()
      }
    })

    /* MP3 */
    if (self.type == 'mp3') {
      if (self.audio == undefined) {
        self.audio = new Audio(self.el.button.data('audio-file'))
      }
      self.audio.play()
      self.update()
      $(self.audio).on('ended', self.ended)
      clearInterval(self.progress_interval)
      self.progress_interval = setInterval(self.update, 100)

    /* SOUNDCLOUD */
    } else if (self.type == 'soundcloud' && self.player != undefined) {
      self.player.play()
    }
  }

  self.pause = function() {
    let wasPlaying = false
    if (self.hasClass('sound-row--playing')) {
      wasPlaying = true
    }
    self.removeClass('sound-row--playing').addClass('sound-row--paused')
    if (wasPlaying) {
      self.addClass('sound-row--just-paused')
    }
    self.playing = false

    if (self.type == 'mp3' && self.audio != undefined) {
      self.audio.pause()
      $(self.audio).off('ended')
      clearInterval(self.progress_interval)
    } else if (self.type == 'soundcloud' && self.player != undefined) {
      self.player.pause()
    }

    requestAnimationFrame(function() {
      self.removeClass('sound-row--just-paused')
    })
  }

  self.update = function() {
    if (self.type == 'mp3' && self.audio != undefined) {
      self.ring_progress(self.audio.currentTime / self.audio.duration * 100)
    }
    return self
  }

  self.clicked = function(e) {
    if (self.ending) {
      return
    }
    e.preventDefault()
    if (self.playing) {
      self.pause()
    } else {
      self.play()
    }
  }

  self.ended = function() {
    self.playing = false
    self.addClass('sound-row--ended').removeClass('sound-row--playing sound-row--paused')

    if (self.type == 'mp3') {
      $(self.audio).off('ended')
      clearInterval(self.progress_interval)
    }

    setTimeout(function() {
      self.removeClass('sound-row--ended')
      self.ring_progress(0)
    }, 250)
  }

  self.ring_progress = function(progress) {
    if (self.type == 'soundcloud' && self.player != undefined) {
      progress = (progress.currentPosition / 1000) / self.duration * 100
    }
    let ringSize = 108,
    strokeWidth = 3,
    arcLength = 2 * Math.PI * (ringSize / 2) - strokeWidth,
    arcOffset = arcLength * (progress/100)
    self.el.progress.attr('stroke-dasharray', arcOffset + 'px 1000px')
  }

  return function() {
    if (self.type == 'soundcloud' && self.player != undefined) {
      self.player.bind(SC.Widget.Events.PLAY_PROGRESS, self.ring_progress)
      self.player.bind(SC.Widget.Events.FINISH, self.finish)
      self.duration = self.find('iframe').data('duration')
    }
    self.el.button.on('click', self.clicked)
    self.ring_progress(0)
    self.data('sound-row', self)
    return self
  }()
}
